export enum V2CardAgentToolName {
  //General tools
  ReadValuesFromExcel = 'readValuesFromExcel',
  GetCardDetails = 'getCardDetails',
  SetCardName = 'setCardName',
  SetCardDescription = 'setCardDescription',
  DeleteOutputs = 'deleteOutputs',

  //Condition card tools
  SearchSignal = 'searchSignal',
  SetSignal = 'setSignal',
  SetOperator = 'setOperator',
  SearchFeedValues = 'searchFeedValues',
  AddOrUpdateConditionCard = 'addOrUpdateConditionCard',
  AddConditionOutput = 'addConditionOutput',
  UpdateConditionOutput = 'updateConditionOutput',
  RemoveConditionOutput = 'removeConditionOutput',
  SubmitCard = 'submitCard',

  //Schedule card tools
  AddOrUpdateScheduleCard = 'addOrUpdateScheduleCard',
  SetScheduleType = 'setScheduleType',
  SetTimezoneSource = 'setTimezoneSource',
  SetTimeZone = 'setTimeZone',
  SetRandomizeOutputs = 'setRandomizeOutputs',
  AddScheduleOutput = 'addScheduleOutput',
  EditScheduleOutput = 'editScheduleOutput',

  //Weighted card tools
  AddOrUpdateWeightedCard = 'addOrUpdateWeightedCard',
  SetShouldSplitAudience = 'setShouldSplitAudience',
  AddWeightedOutput = 'addWeightedOutput',
  EditWeightedOutput = 'editWeightedOutput',
  DeleteWeightedOutputs = 'deleteWeightedOutputs',

  //Distribution card tools
  AddOrUpdateDistributionCard = 'addOrUpdateDistributionCard',
  AddDistributionOutput = 'addDistributionOutput',
  EditDistributionOutput = 'editDistributionOutput',
  DeleteDistributionOutputs = 'deleteDistributionOutputs',

  //Sequence card tools
  AddOrUpdateSequenceCard = 'addOrUpdateSequenceCard',
  AddRegularOutput = 'addRegularOutput',
  EditRegularOutput = 'editRegularOutput',
  DeleteRegularOutputs = 'deleteRegularOutputs',
  SetRepeatCycle = 'setRepeatCycle',

  //Optimization card tools
  AddOrUpdateOptimizationCard = 'addOrUpdateOptimizationCard',
  SetOptimizeBy = 'setOptimizeBy',
  SetOptimizeAcross = 'setOptimizeAcross',
  AddOptimizationOutput = 'addOptimizationOutput',
  UpdateOptimizationOutput = 'updateOptimizationOutput',
  SetOptimizationGoal = 'setOptimizationGoal',
  GetOptimizeByOptions = 'getOptimizeByOptions',
  SetAttributionSignals = 'setAttributionSignals',
  GetAttributionSignals = 'getAttributionSignals',
  DeleteOptimizationOutputs = 'deleteOptimizationOutputs',

  //Creative card tools
  AddOrUpdateCreativeCard = 'addOrUpdateCreativeCard',
  SetCreative = 'setCreative',
  SetIsFallback = 'setIsFallback',

  //Product card tools
  AddOrUpdateProductCardV2 = 'addOrUpdateProductCardV2',
  GetStrategies = 'getStrategies',
  SetStrategy = 'setStrategy',
  SetFeed = 'setFeed',
  SetRelatedItemLogic = 'setRelatedItemLogic',
  SetSpecificItems = 'setSpecificItems',
  SearchMatchingSignals = 'searchMatchingSignals',
  SearchFeedColumns = 'searchFeedColumns',
  SetMatchingConditions = 'setMatchingConditions',
  AddProductOutput = 'addProductOutput',
  EditProductOutput = 'editProductOutput',
  DeleteProductOutputs = 'deleteProductOutputs',

  //Content card tools
  AddOrUpdateContentCard = 'addOrUpdateContentCard',
  SearchContentFeeds = 'searchContentFeeds',
  SetContentStrategy = 'setContentStrategy',
  SetContentFeed = 'setContentFeed',
  SetContentSet = 'setContentSet',
  SetSpecificContent = 'setSpecificContent',
  SearchContentFeedColumns = 'searchContentFeedColumns',
  SearchContentSignals = 'searchContentSignals',

  //Compound condition card tools
  AddOrUpdateCompoundConditionCard = 'addOrUpdateCompoundConditionCard',
  AddCompoundConditionOutput = 'addCompoundConditionOutput',
  EditCompoundConditionOutput = 'editCompoundConditionOutput',

  //Location card tools
  AddOrUpdateLocationCard = 'addOrUpdateLocationCard',
  SetLocationFeed = 'setLocationFeed',
  SetLocationSet = 'setLocationSet',
  SetLocationTargetingMethod = 'setLocationTargetingMethod',
  SetMaxDistance = 'setMaxDistance',
  SetTopLocations = 'setTopLocations',
  SearchLocationFeeds = 'searchLocationFeeds',
  SearchLocationSets = 'searchLocationSets',
}
